// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d5-j";
export var fulfillmentFormRail = "_d5-i";
export var headerTitleRow = "_d5-l";
export var orderDetailsWrapper = "_d5-g";
export var orderLinkTrigger = "_d5-2";
export var paymentInformationGrid = "_d5-q";
export var paymentSummaryColumn = "_d5-r";
export var phoneShipmentPickerButton = "_d5-e";
export var phoneShipmentPickerButtonContent = "_d5-f";
export var phoneShipmentPickerButtonWrapper = "_d5-d";
export var phoneShipmentPickerTrigger = "_d5-c";
export var shipmentContainer = "_d5-k";
export var shipmentDetailsMainPane = "_d5-h";
export var shipmentNavigationCard = "_d5-a";
export var shipmentNavigationEdgeTrigger = "_d5-6";
export var shipmentNavigationRail = "_d5-3";
export var shipmentNavigationRailEnter = "_d5-5";
export var shipmentNavigationRailHeader = "_d5-9";
export var shipmentNavigationRailOverlay = "_d5-4";
export var shipmentNavigationScrim = "_d5-7";
export var shipmentSummaryFact = "_d5-n";
export var shipmentSummaryGrid = "_d5-m";
export var shipmentSummaryMetadataRow = "_d5-o";
export var shipmentSummaryTags = "_d5-p";
export var shipmentWorkspace = "_d5-0";
export var shipmentWorkspaceBodyTablet = "_d5-8";
export var shipmentWorkspaceContent = "_d5-b";
export var shipmentWorkspaceHeader = "_d5-1";